import { IconButton } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { CloseCircleFilled } from '@ant-design/icons';
import styled from 'styled-components';
import { updateUI } from 'store/UI/actions';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SentryWrap from 'components/Sentry';

export default function EngageView({ data, showPacingArrow = true, onClose }) {
  const pacingContainerRef = useRef(null);
  const firstPacingImageRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(updateUI({ openEngageModalTeacher: {} }));
    };
  }, [location.pathname]);

  return (
  <SentryWrap>
    <PackingContainer>
      <IconButton
        onClick={() => {
          onClose();
        }}
        style={{ position: 'absolute', top: '-22px', right: '-20px' }}
      >
        <CloseCircleFilled
          style={{ color: 'red', backgroundColor: 'white', borderRadius: '50%' }}
        />
      </IconButton>

      <VerticalScrollContainer ref={pacingContainerRef}>
        {data.length > 0 && showPacingArrow && (
          <div className="animateArowCstm">
            <AnimatedArrowWrapper>
              <AnimatedArrow direction="down" />
            </AnimatedArrowWrapper>
          </div>
        )}

        {data?.map((src, index) => (
          <ImageItem
            key={index}
            src={src?.resource}
            alt={`Image ${index + 1}`}
            ref={index === 0 ? firstPacingImageRef : null}
          />
        ))}
      </VerticalScrollContainer>
    </PackingContainer>
  </SentryWrap>
  );
}

const AnimatedArrow = ({ onClick, direction }) => {
  const isUp = direction === 'up';

  return (
    <AnimatedArrowContainer onClick={onClick} className={`animated-arrow ${!isUp ? 'up' : ''}`}>
      <AnimatedArrowBottom isAtBottom={isUp}>
        <ArrowCircleTop />
        <ArrowCircle className="circle-top" />
        <ArrowCircle className="circle-main" />
        <ArrowCircle className="circle-bottom" />
        <ArrowCircleBottom />
        <ArrowSvg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 612 612"
          style={{ enableBackground: 'new 0 0 612 612' }}
          xmlSpace="preserve"
        >
          {/* same defs and filter */}
          <path
            className="st-arrow"
            d="M317.5,487.6c0.3-0.3,0.4-0.7,0.7-1.1l112.6-112.6c6.3-6.3,6.3-16.5,0-22.7c-6.3-6.3-16.5-6.3-22.7,0
                        l-86,86V136.1c0-8.9-7.3-16.2-16.2-16.2c-8.9,0-16.2,7.3-16.2,16.2v301.1l-86-86c-6.3-6.3-16.5-6.3-22.7,0
                        c-6.3,6.3-6.3,16.5,0,22.7l112.7,112.7c0.3,0.3,0.4,0.7,0.7,1c0.5,0.5,1.2,0.5,1.7,0.9c1.7,1.4,3.6,2.3,5.6,2.9
                        c0.8,0.2,1.5,0.4,2.3,0.4C308.8,492.6,313.8,491.3,317.5,487.6z"
          />
        </ArrowSvg>
        <style jsx>{`
          .animated-arrow {
            text-align: center;
            width: 100px;
            height: 100px;
            position: relative;
            cursor: pointer;
            filter: url('#goo');
          }

          .animated-arrow.down {
            transform: rotate(180deg);
          }

          .arrow-body {
            position: absolute;
            left: 50%;
            top: 10px;
            animation: blob-1-anim 2s infinite ease-in-out;
            transform: translateX(-50%);
          }

          .circle-top,
          .circle-main,
          .circle-bottom {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #ccc;
            position: absolute;
            left: 50%;
          }

          .circle-top {
            top: 0;
            animation: blob-2-anim 2s infinite ease-in-out;
          }

          .circle-main {
            top: 20px;
          }

          .circle-bottom {
            top: 40px;
            animation: rotate-circle 4s linear infinite;
          }

          .arrow-svg {
            width: 40px;
            height: 40px;
            position: absolute;
            top: 60px;
            left: 50%;
            transform: translateX(-50%);
            animation: scrolly 3s infinite ease-in-out;
          }

          .st-arrow {
            fill: #000;
          }

          @keyframes blob-1-anim {
            0% {
              transform: translateX(-50%) translateY(0);
            }
            14% {
              transform: translateX(-50%) translateY(-8px);
            }
            24% {
              transform: translateX(-50%) translateY(0);
            }
            100% {
              transform: translateX(-50%) translateY(0);
            }
          }

          @keyframes blob-2-anim {
            0%,
            30%,
            70% {
              transform: scale(1) translate(-50%, 10px);
            }
            95% {
              transform: scale(1) translate(-50%, 26px);
            }
            100% {
              transform: scale(1) translate(-50%, 10px);
            }
          }

          @keyframes scrolly {
            0% {
              transform: translate3d(0, -150%, 0) rotateX(90deg) scale(0.5) skewX(3deg);
            }
            30%,
            70% {
              transform: translate3d(0, 0, 0) rotateX(0deg) scale(1) skewX(0deg);
            }
            95%,
            100% {
              transform: translate3d(0, 50%, 0) rotateX(-90deg) scale(0.5) skewX(-3deg);
            }
          }

          @keyframes rotate-circle {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(180deg);
            }
          }
        `}</style>
      </AnimatedArrowBottom>
    </AnimatedArrowContainer>
  );
};

const ImageItem = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  display: block;
`;

const ArrowSvg = styled.svg`
  z-index: 9;
  position: relative;
  background: linear-gradient(to right, #f45c43, #ffb347);
  border-radius: 50%;
  display: inline-block;
  height: 56px;
  width: 56px;

  .st-arrow {
    fill: #fff;
    animation: scrolly 3s cubic-bezier(0.77, 0, 0.175, 1) forwards infinite;
    perspective: 9000px;
    transform: translateZ(0);
    transform-origin: bottom;
  }
`;

const AnimatedArrowContainer = styled.div`
  margin: 0 auto;
  text-align: center;
  width: 56px;
  height: 56px;
  position: relative;
  cursor: pointer;
  filter: url('#goo');
`;

const PackingContainer = styled.div`
  background: white;
  height: 93%;
  width: 100%;
  position: absolute;
  top: 36px;
`;

const VerticalScrollContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

  /* Hide scrollbars */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

const AnimatedArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
`;

const ArrowCircle = styled.div`
  background: linear-gradient(to right, #f45c43, #ffb347);
  border-radius: 50%;
  display: inline-block;
  height: 56px;
  width: 56px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  transform-origin: 0%;
`;

const AnimatedArrowBottom = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  transform: ${(props) => (props.isAtBottom ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0s ease;
`;

const ArrowCircleTop = styled(ArrowCircle)`
  height: 18.67px; // 33.33% of 56
  width: 18.8px; // ~55% of 56
  animation: blob-1-anim 3s cubic-bezier(0.77, 0, 0.175, 1) infinite;
  z-index: 0;
  top: 0;
`;
const ArrowCircleBottom = styled(ArrowCircle)`
  height: 30.8px;
  width: 30.8px;
  animation: blob-2-anim 3s cubic-bezier(0.77, 0, 0.175, 1) infinite;
  z-index: 9;
  top: 10px;
`;
